import { render, staticRenderFns } from "./medicalTestInfo.vue?vue&type=template&id=10047be1&scoped=true&"
import script from "./medicalTestInfo.vue?vue&type=script&lang=js&"
export * from "./medicalTestInfo.vue?vue&type=script&lang=js&"
import style0 from "./medicalTestInfo.vue?vue&type=style&index=0&id=10047be1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10047be1",
  null
  
)

export default component.exports